import { Modal } from "@carbon/react"

type Props = {
    open: boolean
    modalHeading: string
    modalLabel: string
    primaryButtonText?: string
    secondaryButtonText?: string
    onSubmit: () => void
    onClose: () => void
}
function DangerModal(props: Props) {
    const { open, modalHeading, modalLabel, primaryButtonText = 'Delete', secondaryButtonText = 'Cancel', onSubmit, onClose } = props

    const handleSubmit = () => {
        onSubmit()
        onClose()
    }
    
    return (
        <Modal open={open} onRequestClose={onClose} onRequestSubmit={handleSubmit} danger modalHeading={modalHeading} modalLabel={modalLabel} primaryButtonText={primaryButtonText} secondaryButtonText={secondaryButtonText} />
    )
}

export default DangerModal